export const tileGradients = [
  "from-blue-500 to-indigo-600", // Blue to Indigo
  "from-purple-500 to-pink-500", // Purple to Pink
  "from-cyan-500 to-blue-500", // Cyan to Blue
  "from-rose-500 to-orange-500", // Rose to Orange
  "from-emerald-500 to-teal-600", // Emerald to Teal
  "from-violet-500 to-purple-600", // Violet to Purple
  "from-amber-500 to-orange-600", // Amber to Orange
  "from-blue-500 to-cyan-500", // Blue to Cyan
  "from-fuchsia-500 to-pink-600", // Fuchsia to Pink
  "from-teal-500 to-emerald-600" // Teal to Emerald
]
